declare let THREE: any;
import {IColorChangeable} from '../Interfaces';

export class Line extends (THREE.Line as { new(geometry, material): any; }) implements IColorChangeable {

  private static readonly transformation =
    new THREE.Matrix4().makeTranslation(-1 / 2, 0, 0)
      .multiply(new THREE.Matrix4().makeRotationX(THREE.Math.degToRad(90)));

  static readonly Name = 'Line';

  constructor(thickness: number = 1) {
    // const geometry = new THREE.PlaneBufferGeometry(1, thickness).applyMatrix(Line.transformation);
    // const material = new THREE.MeshBasicMaterial({color: 0x000000, side: THREE.DoubleSide});
    const geometry = new THREE.Geometry();
    geometry.vertices.push(
      new THREE.Vector3( 0, 0, 0 ),
      new THREE.Vector3( 1, 0, 0 )
    );
    const material = new THREE.LineBasicMaterial({
      color: 0x000000
    });
    super(geometry, material);
    this.name = Line.Name;
  }

  update(startPoint, endPoint) {
    this.rotation.y = -Math.atan2(startPoint.z - endPoint.z, startPoint.x - endPoint.x) + Math.PI;
    this.scale.x = endPoint.distanceTo(startPoint) || 1;
  }

  setColor(color): void {
    this.material.color.copy(color);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Line.ts